import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { paypalConnect } from 'modules/profile/payment-gateways/integrations/paypal-soap/api';
import { PaymentPaypalInterface } from 'modules/profile/payment-gateways/integrations/paypal-soap/types';
import { getPaypalHelpPageLink } from 'modules/profile/payment-gateways/integrations/paypal-soap/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: PaymentPaypalInterface = {
  username: '',
  password: '',
  signature: ''
};
const defaultErrors: PaymentPaypalInterface = {
  username: '',
  password: '',
  signature: ''
};
const PaypalCreateModal = () => {
  const $ = _c(41);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const [opened, setOpened] = useState(false);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  const [errors, setErrors] = useState(defaultErrors);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await paypalConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t || $[8] !== tUi) {
    t4 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.PaypalSoap, tUi)
    });
    $[7] = t;
    $[8] = tUi;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(false);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = user?.dashboardLocale;
  let t7;
  if ($[11] !== t6) {
    t7 = getPaypalHelpPageLink(t6);
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== tUi) {
    t8 = getPaymentProcessorTitle(PaymentProcessorEnum.PaypalSoap, tUi);
    $[13] = tUi;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <HelpCenterLink link={t7} integration={t8} />;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== errors || $[19] !== t) {
    t10 = {
      field: "username",
      onRender: (value, onChange) => <FormInput key="paypal-username-create" label={t("global.username")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.username} />
    };
    $[18] = errors;
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== errors || $[22] !== t) {
    t11 = {
      field: "password",
      onRender: (value_0, onChange_0) => <FormInput key="paypal-password-create" label={t("global.password")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.password} />
    };
    $[21] = errors;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== errors || $[25] !== t) {
    t12 = {
      field: "signature",
      onRender: (value_1, onChange_1) => <FormInput key="paypal-signature-create" label={t("dashboard.settings.payment_gateways.signature")} value={value_1} onChange={e_2 => onChange_1(e_2.target.value)} error={errors.signature} />
    };
    $[24] = errors;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12) {
    t13 = [t10, t11, t12];
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["username", "password", "signature"];
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== onCreate || $[33] !== opened || $[34] !== t13 || $[35] !== t4 || $[36] !== t9) {
    t15 = <CreateModal fullCaption={t4} opened={opened} onClose={t5} needToast={false} additionalInfo={t9} defaultValues={defaultValues} creatable={t13} onCreate={onCreate} requiredFields={t14} />;
    $[32] = onCreate;
    $[33] = opened;
    $[34] = t13;
    $[35] = t4;
    $[36] = t9;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15 || $[39] !== t3) {
    t16 = <>{t3}{t15}</>;
    $[38] = t15;
    $[39] = t3;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
export default PaypalCreateModal;